<template>
    <div>
        <!-- Banner区域 -->
        <div class="ab_ban" style="background-image:url(/images/n_ban4.jpg);">
        </div>

        <!-- 公司介绍 -->
        <div class="ny_gy" id="lm_a">
            <div class="container">
                <div class="row">
                    <div class="gy_tp wow fadeInLeft" data-wow-delay=".5s"><img src="/images/ny1.jpg"></div>
                    <div class="gy_wz wow fadeInRight" data-wow-delay=".5s">
                        <div class="gy_bt">
                            <h1>Who Are We?</h1>
                        </div>
                        <div class="w_z">CNHONOR GROUP has six affiliated subsidiaries under its umbrella., two of which
                            are manufacturing enterprises: Shandong Huayu Mechanical Equipment Co., Ltd. (hereinafter
                            referred to as HONYO) and Shandong Aonaer Refrigeration Science & Technology Co., Ltd.
                            (hereinafter referred to as CNHONOR).<br><br>
                            HONYO specializes in the design and manufacturing of slaughtering equipment for pig, cattle
                            and sheep, meat cutting lines (including both conventional and intelligent models), conveyor
                            line, clean and disinfection equipment , locker room facilities, as well as process tools
                            and accessories.<br><br>
                            CNHONOR focuses on the R&D and production of refrigeration equipment. Its core product
                            portfolio includes spiral quick freezers, tunnel quick freezers, fluidized bed freezers,
                            hydraulic plate freezers, and complete cold storage solutions (encompassing compressor
                            units, air coolers, condensers, cold storage doors and panels). We also offers intelligent
                            tunnel quick freezing system and automated high-bay cold storage facilities.<br><br>
                            CNHONOR group owns its proprietary production plants and specializes in the turnkey delivery
                            of complete projects. We provide a one-stop integrated solution covering the whole project
                            lifecycle, including preliminary project planning, factory layout design, production line
                            schematic drawing, project manufacturing, transportation, as well as on-site installation
                            and commissioning. With a wealth of domestic and overseas project experience accumulated
                            from numerous projects over the years, our full-package turnkey service spares you the
                            trouble of coordinating with multiple suppliers. Every link of the project is seamlessly
                            connected and well-integrated, saving your time, labor and worries throughout the entire
                            process!</div>
                    </div>
                </div>
                <div class="sj_zs">
                    <ul class="row">
                        <li class="wow fadeInUp" data-wow-delay=".3s">
                            <div class="s_z"><b ref="counter1" class="counter">30</b>+</div>
                            <div class="x_j">National Distribution</div>
                        </li>
                        <li class="wow fadeInUp" data-wow-delay=".4s">
                            <div class="s_z"><b ref="counter2" class="counter">3000</b>+</div>
                            <div class="x_j">Collaboration Cases</div>
                        </li>
                        <li class="wow fadeInUp" data-wow-delay=".5s">
                            <div class="s_z"><b ref="counter3" class="counter">280</b>+</div>
                            <div class="x_j">Number of patents</div>
                        </li>
                        <li class="wow fadeInUp" data-wow-delay=".6s">
                            <div class="s_z"><b ref="counter4" class="counter">40</b>Billion +</div>
                            <div class="x_j">Annual turnover</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 视频弹窗（保留结构，无实际功能） -->
        <div class="tc_sp" v-show="videoVisible">
            <div class="g_b"><i class="iconfont icon-guanbi"></i></div>
            <div class="vd_nr"></div>
        </div>

        <!-- 企业历程 -->
        <div class="gs_lc" id="lm_b">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Enterprise Chronicle</h1>
                </div>
                <div class="lc_zs wow fadeInUp" data-wow-delay=".5s">
                    <ul>
                        <li>
                            <span>2003</span>
                            <h2>Shandong Huayu Mechanical Equipment Co., Ltd. was established.</h2>
                        </li>
                        <li>
                            <span>2011</span>
                            <h2>Shandong Aonaer Refrigeration Science and Technology Co., Ltd. was established.</h2>
                        </li>
                        <li>
                            <span>2014</span>
                            <h2>One-Stop Engineering Co., Ltd. was established.</h2>
                        </li>
                        <li>
                            <span>2014</span>
                            <h2>Binzhou Aonaer Refrigeration Engineering Co., Ltd. was established.</h2>
                        </li>
                        <li>
                            <span>2018</span>
                            <h2>FIS Intelligent Equipment Co., Ltd. was established.</h2>
                        </li>
                        <li>
                            <span>2022</span>
                            <h2>CNHONOR Group was Established.</h2>
                        </li>
                        <li>
                            <span>2022</span>
                            <h2>Shandong Huayuan Chuangzhi Information Technology Co., Ltd. was established.</h2>
                        </li>
                        <!-- <li>
                            <span>2025</span>
                            <h2>International Sales Department</h2>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>

        <!-- 企业文化 -->
        <div class="gs_wh" id="lm_c">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Corporate Culture</h1>
                </div>
                <div class="row wow fadeInUp" data-wow-delay=".5s">
                    <div class="yj_nr" style="background:url(/images/bj_1.jpg) no-repeat center / cover;">
                        <div class="n_r">
                            <div class="t_b"><img src="/images/yj1.png" alt="" title=""></div>
                            <div class="b_t">Vision</div>
                            <div class="w_z">MRO Supply Chain Service Platform for Meat Industry</div>
                        </div>
                    </div>
                    <div class="yj_qt">
                        <ul>
                            <li style="background:url(/images/bj_2.jpg) no-repeat center / cover;">
                                <div class="t_b"><img src="/images/yj2.png" alt="" title=""></div>
                                <div class="b_t">Mission</div>
                                <div class="w_z">Strengthening national brands and achieving global customers</div>
                            </li>
                            <li style="background:url(/images/bj_3.jpg) no-repeat center / cover;">
                                <div class="t_b"><img src="/images/yj3.png" alt="" title=""></div>
                                <div class="b_t">Values</div>
                                <div class="w_z">Integrity, Gratitude, Innovation, and Responsibility</div>
                            </li>
                            <li style="background:url(/images/bj_4.jpg) no-repeat center / cover;">
                                <div class="t_b"><img src="/images/yj4.png" alt="" title=""></div>
                                <div class="b_t">Business Philosophy</div>
                                <div class="w_z">Talent driven quality leadership</div>
                            </li>
                            <li style="background:url(/images/bj_5.jpg) no-repeat center / cover;">
                                <div class="t_b"><img src="/images/yj5.png" alt="" title=""></div>
                                <div class="b_t">Service Tenet</div>
                                <div class="w_z">Efficient service to the utmost goodness and beauty</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 公益板块 -->
        <div class="gs_tz" id="lm_d">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Public Welfare</h1>
                </div>
                <div class="tz_zs wow fadeInUp" data-wow-delay=".5s">
                    <ul>
                        <li class="on">
                            <div class="tz_js">
                                <div class="x_b">Remember the revolutionary martyrs and pass on the red gene!</div>
                                <div class="w_z">The Party branch of the Communist Party of China's Aonaer Refrigeration
                                    Technology Co., Ltd. organized all Party members to visit the Martyrs Cemetery in
                                    Boxing County to carry out a themed Party day activity titled "Remembering
                                    Revolutionary Martyrs and Inheriting the Red Gene".</div>
                            </div>
                            <div class="tz_tp"><img src="/images/n1.jpg"></div>
                        </li>
                        <li>
                            <div class="tz_js">
                                <div class="x_b">CNHONOR "Light and Shadow Accompany, Charm Blooming" Women's Day Event
                                </div>
                                <div class="w_z">The Trade Union Committee of Shandong Aonaer Refrigeration Technology
                                    Co., Ltd. has carefully planned an innovative celebration activity for all female
                                    employees to mark the "March 8th" Women's Day.</div>
                            </div>
                            <div class="tz_tp"><img src="/images/n2.jpg"></div>
                        </li>
                        <li>
                            <div class="tz_js">
                                <div class="x_b">Pass on love with passion, and protect life through action!</div>
                                <div class="w_z">Organize employees to carry out the 2025 annual emergency group blood
                                    donation activity, fulfill social responsibility with practical actions, and
                                    safeguard life and health.</div>
                            </div>
                            <div class="tz_tp"><img src="/images/n3.jpg"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 展会板块 -->
        <div class="gs_fc" id="lm_e">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>At The Exhibition</h1>
                </div>
                <div class="row wow fadeInUp" data-wow-delay=".5s">
                    <div class="tc_zs">
                        <div class="d_t"><img src="/images/zh1.jpg"></div>
                        <div class="f_t">
                            <ul class="row">
                                <li><img src="/images/zh2.jpg"></li>
                                <li><img src="/images/zh3.jpg"></li>
                                <li class="q_b"><img src="/images/zh4.jpg"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="tc_zs">
                        <div class="d_t"><img src="/images/zh5.jpg"></div>
                        <div class="f_t">
                            <ul class="row">
                                <li class="q_b"><img src="/images/zh6.jpg"></li>
                                <li><img src="/images/zh2.jpg"></li>
                                <li><span class="ck_gd" @click="openImageModal">View More</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 图片预览弹窗 -->
        <div class="big_img" v-show="imageModalVisible">
            <i class="iconfont icon-guanbi1" @click="closeImageModal"></i>
            <div class="swiper-container swiper-tc" ref="imageSwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh1.jpg"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh2.jpg"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh3.jpg"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh4.jpg"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh5.jpg"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="cell"><img src="/images/zh6.jpg"></div>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou1"></i></div>
            <div class="swiper-button-next"><i class="iconfont icon-zuojiantou1"></i></div>
        </div>
        <el-image-viewer class="codics-pdf-imgup-body-list-preview" v-if="viewerVisible"
            :on-close="() => { viewerVisible = false }" :url-list="srcList" />
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
    data() {
        return {
            srcList: ['/images/zh1.jpg', '/images/zh2.jpg', '/images/zh3.jpg', '/images/zh4.jpg', '/images/zh5.jpg', '/images/zh6.jpg'],
            viewerVisible: false,
            videoVisible: false,
            // 图片预览弹窗状态
            imageModalVisible: false,
            // Swiper实例
            imageSwiperInstance: null,
            // 数字计数是否初始化
            counterInited: false
        }
    },
    mounted() {
        // 处理锚点滚动
        this.handleAnchorScroll()
        // 初始化数字计数
        this.initCounter()
        // 初始化WOW动画（如需保留）
        // if (window.WOW) new window.WOW().init()
    },
    beforeDestroy() {
        // 销毁Swiper实例
        if (this.imageSwiperInstance) {
            this.imageSwiperInstance.destroy(true, true)
        }
    },
    methods: {
        // ========== 图片预览弹窗 ==========
        openImageModal() {
            this.viewerVisible = true;
            // 延迟初始化Swiper（确保DOM渲染完成）

        },
        closeImageModal() {
            this.imageModalVisible = false
        },

        // ========== 图片预览Swiper初始化 ==========
        initImageSwiper() {
            if (this.imageSwiperInstance) return

            this.imageSwiperInstance = new Swiper(this.$refs.imageSwiper, {
                observer: true,
                observeParents: true,
                loop: false,
                speed: 1000,
                pagination: {
                    el: '.big_img .swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.big_img .swiper-button-next',
                    prevEl: '.big_img .swiper-button-prev'
                }
            })
        },

        // ========== 锚点滚动处理 ==========
        handleAnchorScroll() {
            // 获取当前URL中的锚点
            const href = window.location.href
            const pos = href.indexOf('#')

            if (pos === -1) return

            // 提取锚点ID
            const anchorId = href.substr(pos)
            const targetElement = document.querySelector(anchorId)
            if (!targetElement) return

            // 获取header高度（模拟原逻辑）
            const headerHeight = document.querySelector('.header')?.offsetHeight || 0
            const targetTop = targetElement.offsetTop - headerHeight

            // 平滑滚动
            window.scrollTo({
                top: targetTop,
                behavior: 'smooth' // 平滑滚动，替代jQuery animate
            })
        },

        // ========== 数字计数动画 ==========
        initCounter() {
            // 计数配置
            const counters = [
                { el: this.$refs.counter1, target: 30, duration: 2000 },
                { el: this.$refs.counter2, target: 3000, duration: 2000 },
                { el: this.$refs.counter3, target: 280, duration: 2000 },
                { el: this.$refs.counter4, target: 40, duration: 2000 }
            ]

            // 监听元素进入视图
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.counterInited) {
                        this.counterInited = true
                        counters.forEach(item => {
                            this.countUp(item.el, item.target, item.duration)
                        })
                        observer.disconnect()
                    }
                })
            }, { threshold: 0.5 })

            // 观察数字统计区域
            observer.observe(document.querySelector('.sj_zs'))
        },

        // 数字递增动画实现
        countUp(el, target, duration) {
            let start = 0
            const step = duration / target
            const timer = setInterval(() => {
                start += 1
                el.textContent = start
                if (start >= target) {
                    clearInterval(timer)
                    el.textContent = target
                }
            }, step)
        },
        initCounter() {
            // 计数配置
            const counters = [
                { el: this.$refs.counter1, target: 30, duration: 1000 },
                { el: this.$refs.counter2, target: 3000, duration: 1000 },
                { el: this.$refs.counter3, target: 280, duration: 1000 },
                { el: this.$refs.counter4, target: 40, duration: 1000 }
            ]

            // 监听元素进入视图
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.counterInited) {
                        this.counterInited = true
                        counters.forEach(item => {
                            this.countUp(item.el, item.target, item.duration)
                        })
                        observer.disconnect()
                    }
                })
            }, { threshold: 0.5 })

            // 观察数字统计区域
            observer.observe(document.querySelector('.sj_zs'))
        },

        // ✅ 按你的思路重写：从0开始 → 按时间递增 → 精准到达目标
        countUp(el, target) {
            // 确保从 0 开始
            let current = 0;
            // 固定时间间隔，模拟“时间节点”
            const interval = 16; // 约60帧，流畅动画
            // 计算总步数
            const totalSteps = Math.ceil(2000 / interval);
            // 每一步增加的数字（均匀分配）
            const increment = target / totalSteps;

            const timer = setInterval(() => {
                // 按时间递增计算当前数字
                current += increment;

                // 整数显示（更美观）
                el.textContent = Math.floor(current);

                // 到达目标结束
                if (current >= target) {
                    clearInterval(timer);
                    el.textContent = target; // 确保最终精准显示目标值
                }
            }, interval);
        }
    },
    components: {
        ElImageViewer
    }
}
</script>
